var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid position-relative bg-BAT-iframe px-0"},[(_vm.loading !== 0)?_c('loading',{staticClass:"position-absolute"}):_vm._e(),_vm._v(" "),(_vm.url)?_c('iframe',{staticClass:"iframe-pedido",attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }